module.exports = __webpack_public_path__ + "img/ve.b2cd5a9.svg";